import React from "react";

const BreadCrumb = ({paths = [], active = 0}) => { 
    return (
        <div className="breadcrumb-container px-4 px-xxl-5 py-3 py-sm-4">
            {
                paths.map((p, i) => {
                    const status = i === active ? 'current' : i < active ? 'active' : 'inactive'
                    const bg = status !== 'inactive' ? 'primary' : 'grey'
                    const color = status === 'current' ? 'dark' : status === 'active' ? 'primary' : 'light-grey'
                    return (
                        <div key={`breadcrumb-step-${i}`} className="breadcrumb-step d-flex align-items-center">
                            <div className={`counter bg-${bg} ms-2`}>
                                {
                                    status === 'active' ? 
                                        <i className={`bx bx-check text-white font-size-20`} /> : (i+1)
                                }
                            </div>
                            <div className={`title text-${color} ${i === paths.length - 1 && 'ps-4'}`}>{p}</div>
                            {
                                i < paths.length - 1 && <div className="mx-2">
                                    <i className='bx bx-chevron-right text-grey'></i>
                                </div>
                            }
                        </div>
                    )
                })
            }
        </div>
    )
}

export default BreadCrumb;